import { render } from "./ActivateType.vue?vue&type=template&id=30135798&scoped=true"
import script from "./ActivateType.vue?vue&type=script&lang=ts"
export * from "./ActivateType.vue?vue&type=script&lang=ts"

import "./ActivateType.vue?vue&type=style&index=0&id=30135798&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30135798"

export default script